import React from 'react'

function MapIcon(props) {
    return (

        <svg width="122" height="128" viewBox="0 0 163 163" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className={props.className} d="M139.229 20.375L138.143 20.5787L101.875 34.6375L61.125 20.375L22.82 33.2792C21.3937 33.7546 20.375 34.9771 20.375 36.5392V139.229C20.375 141.131 21.8692 142.625 23.7708 142.625L24.8575 142.421L61.125 128.362L101.875 142.625L140.18 129.721C141.606 129.245 142.625 128.023 142.625 126.461V23.7708C142.625 21.8692 141.131 20.375 139.229 20.375ZM67.9167 37.1504L95.0833 46.6587V125.85L67.9167 116.341V37.1504ZM33.9583 43.8742L54.3333 37.0146V116.477L33.9583 124.355V43.8742ZM129.042 119.126L108.667 125.985V46.5908L129.042 38.7125V119.126Z" fill="#455A64" stroke="black" />
        </svg>

    )
}

export default MapIcon
